import React from 'react';
import { Link } from 'react-router-dom';
import AppLayout from './AppLayout';

export default function UnavailablePage({ title, description, activeTab = 'home' }) {
  return <AppLayout activeTab={activeTab}>
    <section className="bg-white p-6 rounded-3xl shadow-lg border-t-4 border-[#76263c] text-[#4a1825]">
      <h2 className="text-3xl font-bold font-serif mb-4">{title}</h2>
      <p className="mb-3 font-medium">Not available yet</p>
      <p className="mb-6">{description}</p>
      <Link to="/app" className="inline-block px-4 py-2 bg-[#76263c] text-white rounded-xl">Back to dashboard</Link>
    </section>
  </AppLayout>;
}
